import { render, staticRenderFns } from "./CheckboxDropdownCategories.vue?vue&type=template&id=155acb98&scoped=true&"
import script from "./CheckboxDropdownCategories.vue?vue&type=script&lang=js&"
export * from "./CheckboxDropdownCategories.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxDropdownCategories.vue?vue&type=style&index=0&id=155acb98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155acb98",
  null
  
)

export default component.exports